import React, { useState, useEffect } from 'react';
import { AZUL, LARANJA, CINZA } from '../styles/colors';
import { db, logoutUsuario } from '../firebase';
import { doc, getDoc, updateDoc } from 'firebase/firestore';

function Perfil({ onNavegar, onLogout }) {

  const [editando,  setEditando]  = useState(false);
  const [salvando,  setSalvando]  = useState(false);
  const [loading,   setLoading]   = useState(true);
  const [dados,     setDados]     = useState(null);
  const [form,      setForm]      = useState({});

  useEffect(() => {
    carregarPerfil();
  }, []);

  async function carregarPerfil() {
    setLoading(true);
    try {
      const perfil = JSON.parse(localStorage.getItem('perfil') || 'null');
      if (!perfil?.uid) { setLoading(false); return; }

      const snap = await getDoc(doc(db, 'usuarios', perfil.uid));
      if (snap.exists()) {
        const d = snap.data();
        setDados(d);
        setForm({
          nome:        d.nome        || '',
          razaoSocial: d.razaoSocial || '',
          email:       d.email       || '',
          telefone:    d.telefone    || '',
          cnpj:        d.cnpj        || '',
          rua:         d.endereco?.rua    || '',
          numero:      d.endereco?.numero || '',
          cidade:      d.endereco?.cidade || '',
          estado:      d.endereco?.estado || '',
          cep:         d.endereco?.cep    || '',
        });
      }
    } catch (e) {
      console.error('Erro ao carregar perfil:', e);
    }
    setLoading(false);
  }

  async function handleSalvar() {
    setSalvando(true);
    try {
      const perfil = JSON.parse(localStorage.getItem('perfil') || 'null');
      if (!perfil?.uid) return;

      await updateDoc(doc(db, 'usuarios', perfil.uid), {
        nome:        form.nome,
        razaoSocial: form.razaoSocial,
        telefone:    form.telefone,
        cnpj:        form.cnpj,
        endereco: {
          rua:    form.rua,
          numero: form.numero,
          cidade: form.cidade,
          estado: form.estado,
          cep:    form.cep,
        },
      });

      const atualizado = { ...perfil, nome: form.nome, razaoSocial: form.razaoSocial, telefone: form.telefone, cnpj: form.cnpj };
      localStorage.setItem('perfil', JSON.stringify(atualizado));

      setDados(prev => ({
        ...prev,
        nome: form.nome, razaoSocial: form.razaoSocial, telefone: form.telefone, cnpj: form.cnpj,
        endereco: { rua: form.rua, numero: form.numero, cidade: form.cidade, estado: form.estado, cep: form.cep },
      }));
      setEditando(false);
    } catch (e) {
      console.error('Erro ao salvar:', e);
      alert('Erro ao salvar. Tente novamente.');
    }
    setSalvando(false);
  }

  async function handleLogout() {
    try {
      await logoutUsuario();
      localStorage.removeItem('perfil');
      onLogout();
    } catch (e) {
      console.error('Erro ao sair:', e);
    }
  }

  function handleChange(campo, valor) {
    setForm(prev => ({ ...prev, [campo]: valor }));
  }

  const inputStyle = {
    width: '100%', background: '#f8f8f7', border: '1px solid #e0e0dd',
    borderRadius: 8, padding: '9px 12px', fontSize: 13, outline: 'none',
    boxSizing: 'border-box', color: '#1a1a1a', fontFamily: 'inherit',
  };

  const labelStyle = { fontSize: 11, fontWeight: 500, color: '#888', display: 'block', marginBottom: 4 };
  const campoStyle = { marginBottom: 12 };

  const navItems = [
    { id: 'home',      emoji: '🏠', label: 'Início'   },
    { id: 'catalogo',  emoji: '📦', label: 'Catálogo' },
    { id: 'carrinho',  emoji: '🛒', label: 'Carrinho' },
    { id: 'historico', emoji: '📋', label: 'Pedidos'  },
    { id: 'perfil',    emoji: '👤', label: 'Perfil'   },
  ];

  if (loading) {
    return (
      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', background: CINZA }}>
        <div style={{ textAlign: 'center', color: '#aaa' }}>
          <div style={{ fontSize: 32, marginBottom: 8 }}>⏳</div>
          <div style={{ fontSize: 13 }}>Carregando perfil...</div>
        </div>
      </div>
    );
  }

  if (!dados) {
    return (
      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', background: CINZA }}>
        <div style={{ textAlign: 'center', color: '#aaa' }}>
          <div style={{ fontSize: 32, marginBottom: 8 }}>⚠️</div>
          <div style={{ fontSize: 13 }}>Perfil não encontrado</div>
        </div>
      </div>
    );
  }

  const iniciais = dados.nome?.split(' ').map(n => n[0]).slice(0, 2).join('') || '?';

  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', background: CINZA }}>

      {/* Header */}
      <div style={{ background: AZUL, padding: '14px 18px 0' }}>
        {/* Linha 1: perfil + sair */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 12 }}>
          <div style={{ width: 46, height: 46, borderRadius: '50%', background: LARANJA, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, fontWeight: 700, color: '#fff', flexShrink: 0 }}>
            {iniciais}
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ color: '#fff', fontSize: 14, fontWeight: 600 }}>{dados.nome}</div>
            <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: 11 }}>{dados.email}</div>
          </div>
          <button onClick={handleLogout}
            style={{ background: 'rgba(255,255,255,0.15)', border: 'none', borderRadius: 8, padding: '6px 12px', fontSize: 11, color: '#fff', cursor: 'pointer', fontWeight: 500 }}>
            Sair
          </button>
        </div>
        {/* Linha 2: navegação */}
        <div style={{ display: 'flex', borderTop: '1px solid rgba(255,255,255,0.15)' }}>
          {navItems.map(item => (
            <div key={item.id} onClick={() => onNavegar(item.id)}
              style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '8px 4px 10px', cursor: 'pointer', gap: 3, borderBottom: item.id === 'perfil' ? '2px solid #fff' : '2px solid transparent' }}>
              <span style={{ fontSize: 18 }}>{item.emoji}</span>
              <span style={{ fontSize: 9, color: item.id === 'perfil' ? '#fff' : 'rgba(255,255,255,0.6)', fontWeight: item.id === 'perfil' ? 600 : 400 }}>{item.label}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Conteúdo */}
      <div style={{ flex: 1, overflowY: 'auto', padding: '14px 14px 0' }}>

        {/* Dados pessoais */}
        <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e8e8e5', padding: '14px 16px', marginBottom: 12 }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
            <span style={{ fontSize: 13, fontWeight: 600, color: '#1a1a1a' }}>Dados Pessoais</span>
            {!editando && (
              <button onClick={() => setEditando(true)}
                style={{ background: '#f0f4ff', border: 'none', borderRadius: 8, padding: '5px 12px', fontSize: 11, fontWeight: 600, color: AZUL, cursor: 'pointer' }}>
                ✏️ Editar
              </button>
            )}
          </div>

          {[
            { campo: 'nome',        label: 'Nome completo',       type: 'text'  },
            { campo: 'razaoSocial', label: 'Razão Social',        type: 'text'  },
            { campo: 'email',       label: 'E-mail',              type: 'email', disabled: true },
            { campo: 'telefone',    label: 'Telefone / WhatsApp', type: 'tel'   },
            { campo: 'cnpj',        label: 'CNPJ / CPF',          type: 'text'  },
          ].map(f => (
            <div key={f.campo} style={campoStyle}>
              <label style={labelStyle}>{f.label}</label>
              {editando && !f.disabled ? (
                <input value={form[f.campo]} onChange={e => handleChange(f.campo, e.target.value)} style={inputStyle} type={f.type} />
              ) : (
                <div style={{ fontSize: 13, color: f.disabled ? '#aaa' : '#1a1a1a' }}>{dados[f.campo] || '—'}</div>
              )}
            </div>
          ))}
        </div>

        {/* Endereço */}
        <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e8e8e5', padding: '14px 16px', marginBottom: 12 }}>
          <div style={{ fontSize: 13, fontWeight: 600, color: '#1a1a1a', marginBottom: 14 }}>Endereço de Entrega</div>

          <div style={campoStyle}>
            <label style={labelStyle}>Rua / Avenida</label>
            {editando ? <input value={form.rua} onChange={e => handleChange('rua', e.target.value)} style={inputStyle} /> : <div style={{ fontSize: 13, color: '#1a1a1a' }}>{dados.endereco?.rua || '—'}</div>}
          </div>
          <div style={campoStyle}>
            <label style={labelStyle}>Número</label>
            {editando ? <input value={form.numero} onChange={e => handleChange('numero', e.target.value)} style={inputStyle} /> : <div style={{ fontSize: 13, color: '#1a1a1a' }}>{dados.endereco?.numero || '—'}</div>}
          </div>
          <div style={{ display: 'flex', gap: 10, marginBottom: 12 }}>
            <div style={{ flex: 1 }}>
              <label style={labelStyle}>Cidade</label>
              {editando ? <input value={form.cidade} onChange={e => handleChange('cidade', e.target.value)} style={inputStyle} /> : <div style={{ fontSize: 13, color: '#1a1a1a' }}>{dados.endereco?.cidade || '—'}</div>}
            </div>
            <div style={{ width: 60 }}>
              <label style={labelStyle}>Estado</label>
              {editando ? <input value={form.estado} onChange={e => handleChange('estado', e.target.value)} style={inputStyle} maxLength={2} /> : <div style={{ fontSize: 13, color: '#1a1a1a' }}>{dados.endereco?.estado || '—'}</div>}
            </div>
          </div>
          <div style={campoStyle}>
            <label style={labelStyle}>CEP</label>
            {editando ? <input value={form.cep} onChange={e => handleChange('cep', e.target.value)} style={inputStyle} /> : <div style={{ fontSize: 13, color: '#1a1a1a' }}>{dados.endereco?.cep || '—'}</div>}
          </div>
        </div>

        {/* Botões edição */}
        {editando && (
          <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
            <button onClick={() => setEditando(false)}
              style={{ flex: 1, background: '#f4f4f2', border: 'none', borderRadius: 10, padding: 13, fontSize: 13, fontWeight: 500, color: '#666', cursor: 'pointer' }}>
              Cancelar
            </button>
            <button onClick={handleSalvar} disabled={salvando}
              style={{ flex: 2, background: AZUL, border: 'none', borderRadius: 10, padding: 13, fontSize: 13, fontWeight: 600, color: '#fff', cursor: 'pointer', opacity: salvando ? 0.7 : 1 }}>
              {salvando ? 'Salvando...' : '✓ Salvar Alterações'}
            </button>
          </div>
        )}

        {/* Representante */}
        {dados.vendedorId && (
          <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e8e8e5', padding: '14px 16px', marginBottom: 12 }}>
            <div style={{ fontSize: 13, fontWeight: 600, color: '#1a1a1a', marginBottom: 12 }}>Meu Representante</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <div style={{ width: 38, height: 38, borderRadius: '50%', background: '#EAF3DE', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 600, color: '#27500A' }}>
                {dados.vendedorId?.slice(0, 2).toUpperCase()}
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 9, color: '#aaa', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Representante Inove</div>
                <div style={{ fontSize: 13, fontWeight: 500, color: '#1a1a1a' }}>Consultor vinculado</div>
              </div>
            </div>
          </div>
        )}

        <div style={{ height: 14 }} />
      </div>
    </div>
  );
}

export default Perfil;